import { css } from '@emotion/react';

import { Box } from 'shared/components/ui';
import { EventInfoFragment, Organization } from 'shared/graphql';
import { useModalState } from 'shared/hooks';

import { Event } from './Event';
import { EventDetailsModal } from './EventInfoModal';

const eventsListBox = theme => css`
  display: grid;
  grid-row-gap: ${theme.spacing(3.125)}px;
  padding-bottom: ${theme.spacing(1.25)}px;
`;

type EventsListProps = {
  eventsList: EventInfoFragment[] | undefined | null;
};

export const EventsList = ({ eventsList }: EventsListProps) => {
  const {
    show: showDetailsModal,
    open: openDetailsModal,
    close: closeDetailsModal,
    params: selectedEvent,
  } = useModalState<EventInfoFragment>();

  return (
    <Box css={eventsListBox}>
      {selectedEvent && (
        <EventDetailsModal
          show={showDetailsModal}
          event={selectedEvent}
          onClose={closeDetailsModal}
        />
      )}

      {eventsList?.map(event => (
        <Event
          key={event.id}
          onEventOpen={() => openDetailsModal(event)}
          date={event.date}
          images={event.images}
          location={event.location}
          title={event.title}
          timezone={event.timezone}
          titleSponsor={event.titleSponsor as Organization}
        />
      ))}
    </Box>
  );
};
